"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrientationOpportunityViewedByNurseSource = void 0;
exports.instanceOfOrientationOpportunityViewedByNurseSource = instanceOfOrientationOpportunityViewedByNurseSource;
exports.OrientationOpportunityViewedByNurseSourceFromJSON = OrientationOpportunityViewedByNurseSourceFromJSON;
exports.OrientationOpportunityViewedByNurseSourceFromJSONTyped = OrientationOpportunityViewedByNurseSourceFromJSONTyped;
exports.OrientationOpportunityViewedByNurseSourceToJSON = OrientationOpportunityViewedByNurseSourceToJSON;
exports.OrientationOpportunityViewedByNurseSourceToJSONTyped = OrientationOpportunityViewedByNurseSourceToJSONTyped;
/**
 *
 * @export
 */
exports.OrientationOpportunityViewedByNurseSource = {
    DetailsPage: 'details_page'
};
function instanceOfOrientationOpportunityViewedByNurseSource(value) {
    for (const key in exports.OrientationOpportunityViewedByNurseSource) {
        if (Object.prototype.hasOwnProperty.call(exports.OrientationOpportunityViewedByNurseSource, key)) {
            if (exports.OrientationOpportunityViewedByNurseSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function OrientationOpportunityViewedByNurseSourceFromJSON(json) {
    return OrientationOpportunityViewedByNurseSourceFromJSONTyped(json, false);
}
function OrientationOpportunityViewedByNurseSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function OrientationOpportunityViewedByNurseSourceToJSON(value) {
    return value;
}
function OrientationOpportunityViewedByNurseSourceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=OrientationOpportunityViewedByNurseSource.js.map